import {IStore} from "modules/types";
import {createSelector} from "reselect";

const getState = ({help}: IStore) => help;

export const getHelps = createSelector(getState, (state) => state);
